import React from 'react';
import { useParams } from 'react-router-dom';
import VideoCallRoom from './VideoCallRoom';

const JoinTelehealthSession = () => {
  const { sessionId } = useParams();

  if (!sessionId) {
    return <div>Invalid session link.</div>;
  }

  // You may want to add logic to determine patientId/providerId based on auth or query params
  return (
    <VideoCallRoom
      sessionId={sessionId}
      // patientId and providerId can be passed if available
    />
  );
};

export default JoinTelehealthSession; 